import { createIcon } from '../createIcon.tsx';

export const DropletIcon = createIcon(
	'DropletIcon',
	<path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5S12.5 5 12 2c-.5 3-2 4.9-4 6.5C6 10.1 5 12 5 14a7 7 0 0 0 7 8z" />,
);
